export default __webpack_public_path__ + "f3dacbc3950da5d3025fabe9574de820.png";